import { useId } from "react";

import FiltersMobileTriggerButton from "components/Filters/MobileTriggerButton";
import SearchInput from "components/SearchInput";
import ViewHeader from "components/ViewHeader";
import ViewHeaderNavigation from "components/ViewHeader/Navigation";
import ViewHeaderTitle from "components/ViewHeader/Title";
import ViewHeaderWrapper from "components/ViewHeader/Wrapper";
import Box from "ds/components/Box";
import Tab from "ds/components/Tab";

type PluginsLayoutProps = {
  actions?: React.ReactNode;
  children?: React.ReactNode;
};

const PluginsLayout = ({ actions, children }: PluginsLayoutProps) => {
  const titleId = useId();

  return (
    <>
      <ViewHeader firstLevel>
        <ViewHeaderTitle>
          <Box justify="center" align="center" gap="medium">
            <ViewHeaderTitle id={titleId}>Plugins</ViewHeaderTitle>
          </Box>
        </ViewHeaderTitle>

        <ViewHeaderWrapper direction="row">
          <SearchInput filtersOrderSettingsKey="plugins" placeholder="Search plugins..." />
          <FiltersMobileTriggerButton />
          {actions}
        </ViewHeaderWrapper>
        <ViewHeaderNavigation>
          <Tab to="/plugins" label="Account plugins" />
          <Tab to="/plugin-templates" label="Templates" />
        </ViewHeaderNavigation>
      </ViewHeader>
      {children}
    </>
  );
};

export default PluginsLayout;
